import { render, staticRenderFns } from "./companies-logos.vue?vue&type=template&id=29252af5&"
import script from "./companies-logos.vue?vue&type=script&lang=js&"
export * from "./companies-logos.vue?vue&type=script&lang=js&"
import style0 from "./companies-logos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports